/*
 * Correctifs VisionPeche pour le widget Judge.me
 * ------------------------------------------------------------------
 * La vignette produit de la fenetre "ecrire un avis" arrive avec
 * loading="lazy" dans un conteneur qui etait masque : le navigateur ne
 * declenche jamais le telechargement et le cadre reste vide, meme quand
 * le fichier est deja en cache. On force le chargement des son apparition.
 *
 * Au passage on demande au CDN Shopify une version redimensionnee : le
 * fichier d'origine fait 1340 px de large pour un affichage de 160 px.
 */
(function () {
  var SELECTEUR =
    '.jdgm-write-review-modal__product-image img, .jdgm-write-review-modal__product img';

  function corriger(img) {
    if (!img || img.dataset.vpCorrige === '1') return;
    img.dataset.vpCorrige = '1';

    img.setAttribute('loading', 'eager');
    img.setAttribute('decoding', 'sync');
    img.setAttribute('fetchpriority', 'high');

    var src = img.getAttribute('src') || '';
    if (!src) return;

    // le CDN Shopify est servi soit depuis cdn.shopify.com, soit depuis
    // le domaine de la boutique sous /cdn/shop/ : les deux acceptent width=
    if (src.indexOf('/cdn/') !== -1 && src.indexOf('width=') === -1) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=480';
    }

    // reaffecter src relance le telechargement immediatement,
    // sans attendre l'IntersectionObserver du chargement differe
    img.src = src;
  }

  function balayer() {
    var images = document.querySelectorAll(SELECTEUR);
    for (var i = 0; i < images.length; i++) corriger(images[i]);
  }

  var planifie = false;
  function planifier() {
    if (planifie) return;
    planifie = true;
    requestAnimationFrame(function () {
      planifie = false;
      balayer();
    });
  }

  new MutationObserver(planifier).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  balayer();
})();
